import { __assign, __extends, __rest } from "tslib";
import * as React from "react";
import { Animated, View, StyleSheet } from "react-native";
import color from "color";
//import MaterialCommunityIcon from '../MaterialCommunityIcon';
import TouchableRipple from "../../TouchableRipple";
import defaultTheme from "../../styles/defaultTheme";
var ANIMATION_DURATION = 100;
var Checkbox = /** @class */function (_super) {
  __extends(Checkbox, _super);
  function Checkbox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      scaleAnim: new Animated.Value(1)
    };
    return _this;
  }
  Checkbox.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.status === this.props.status) {
      return;
    }
    var checked = this.props.status === "checked";
    var animation = this.props.theme.animation;
    Animated.sequence([Animated.timing(this.state.scaleAnim, {
      toValue: 0.85,
      duration: checked ? ANIMATION_DURATION * animation.scale : 0,
      useNativeDriver: false
    }), Animated.timing(this.state.scaleAnim, {
      toValue: 1,
      duration: checked ? ANIMATION_DURATION * animation.scale : ANIMATION_DURATION * animation.scale * 1.75,
      useNativeDriver: false
    })]).start();
  };
  Checkbox.prototype.render = function () {
    var _a = this.props,
      status = _a.status,
      disabled = _a.disabled,
      onPress = _a.onPress,
      theme = _a.theme,
      native = _a.native,
      nativeComponent = _a.nativeComponent,
      rest = __rest(_a, ["status", "disabled", "onPress", "theme", "native", "nativeComponent"]);
    var checked = status === "checked";
    var checkedColor = this.props.color || "#003087";
    var uncheckedColor = this.props.uncheckedColor || color("#003087").alpha(0.54).rgb().string();
    var rippleColor, checkboxColor;
    if (disabled) {
      rippleColor = color("#003087").alpha(0.16).rgb().string();
      checkboxColor = color('#bdbdbd').alpha(0.26).rgb().string();
    } else {
      rippleColor = color(checkedColor).fade(0.32).rgb().string();
      checkboxColor = checked ? checkedColor : uncheckedColor;
    }
    var borderWidth = this.state.scaleAnim.interpolate({
      inputRange: [0.8, 1],
      outputRange: [7, 0]
    });
    var icon = native ? nativeComponent : checked ? (/*#__PURE__*/React.createElement("input", {
      style: {
        width: 20,
        height: 20,
        backgroundColor: "white"
      },
      type: "checkbox",
      checked: true,
      onChange: function () {},
      nativeID: rest.idTag1,
      id: rest.idTag1,
      role: "checkbox",
      "aria-label": "Checkbox"
    })) : (/*#__PURE__*/React.createElement("input", {
      style: {
        width: 20,
        height: 20
      },
      type: "checkbox",
      checked: false,
      onChange: function () {},
      nativeID: rest.idTag1,
      id: rest.idTag1,
      disabled: disabled,
      role: "checkbox",
      "aria-label": "Checkbox"
    }));
    return /*#__PURE__*/React.createElement(TouchableRipple, __assign({}, rest, {
      borderless: true,
      rippleColor: rippleColor,
      onPress: onPress,
      disabled: disabled,
      style: styles.container,
      nativeID: rest.idTag2
    }), /*#__PURE__*/React.createElement(Animated.View, {
      style: {
        transform: [{
          scale: this.state.scaleAnim
        }]
      },
      nativeID: rest.idTag2
    }, icon, /*#__PURE__*/React.createElement(View, {
      style: [StyleSheet.absoluteFill, styles.fillContainer],
      testID: "checkbox",
      nativeID: rest.idTag3
    }, /*#__PURE__*/React.createElement(Animated.View, {
      style: [styles.fill, {
        borderColor: 'black'
      }, {
        borderWidth: borderWidth
      }],
      nativeID: rest.idTag4
    }))));
  };
  return Checkbox;
}(React.Component);
var styles = StyleSheet.create({
  container: {
    borderRadius: 18,
    width: 36,
    height: 36,
    padding: 6,
    alignItems: "center",
    justifyContent: "center"
  },
  fillContainer: {
    alignItems: "center",
    justifyContent: "center"
  },
  fill: {
    height: 14,
    width: 14
  }
});
export default defaultTheme(Checkbox);